export enum ReferralDeliveryMethodEnum {
  GENERIC = "GENERIC",
  TIVLY = "TIVLY",
  HUB = "HUB",
  BOLD_PENGUIN = "BOLD_PENGUIN",
  DATALOT = "DATALOT",
  MOMENTUM = "MOMENTUM",
  CTQ = "CTQ",
  MOMENTUM_AMP = "MOMENTUM_AMP",
  MOMENTUM_VOICE = "MOMENTUM_VOICE",
  QUINSTREET = "QUINSTREET"
}
